<template>
    <div class="b-table-sticky-header table-responsive mt-1 mb-0" style="max-height:375px;">
        <b-table-simple
            class="mt-0 mb-0"
            no-border-collapse
            striped
            small
        >
            <b-thead>
                <b-tr>
                    <b-th
                        class="text-center text-nowrap px-0"
                    >
                        {{ $t('v4.Date') }}
                    </b-th>
                    <b-th
                        v-for="(product, productIdx) in allProducts" :key="productIdx"
                        class="text-right text-nowrap"
                        :style="{'padding-right': allProducts.length < 4 ? '30px' : ''}"
                        style="width:100px;"
                    >
                        {{ product.replace('AWS', '').replace('Amazon', '') }}
                    </b-th>
                </b-tr>
            </b-thead>
            <b-tbody class="table-sm">
                <template v-for="(day, dayIdx) in dataWithCost">
                    <b-tr :key="dayIdx">
                        <b-th
                            class="text-center text-nowrap px-0"
                            style="width:100px;position: sticky;left:0px;z-index:2;"
                            :style="`background-color:${theme === 'dark' ? '#343d55' : '#f3f2f7'};`"
                        >
                            <p class="mb-0 px-2">
                                {{ day.date.substring(5,10) }}
                            </p>
                        </b-th>
                        <b-td
                            class="text-right" v-for="(product, productIdx) in allProducts" :key="productIdx"
                            style="min-width:150px;"
                            :style="{ 'padding-right': allProducts.length < 4 ? '30px' : '' }"
                        >
                            <a
                                v-if="day.products.filter(item => item.productCode == product).length"
                                @click="emitDetailLayerWithProduct(day.date, product)"
                            >
                                {{ $_getDollar(day.products.filter(item => item.productCode == product)[0].cost) }}
                            </a>
                            <span
                                v-else
                            >
                                -
                            </span>
                        </b-td>
                    </b-tr>
                </template>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import { computed, toRefs, inject } from '@vue/composition-api'
export default {
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        dataWithCost: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const theme = inject('theme')
        const { data } = toRefs(props)
        const allProducts = computed(() => {
            return data.value
                .map(item => item.products.map(item => item.productCode))
                .reduce((acc, val) => acc.concat(val), [])
                .filter((obj, pos, arr) => {
                    return arr.indexOf(obj) === pos
                })
        })
        const emitDetailLayerWithProduct = (date, productCode) => {
            context.emit('detail-layer', { date, productCode })
        }
        return {
            allProducts,
            emitDetailLayerWithProduct,
            theme
        }
    }
}
</script>

<style>

</style>
